module.exports = __webpack_public_path__ + "img/penguin.55162ae2.svg";